// Copyright (c) Microsoft. All rights reserved.

import { Body1, makeStyles, Subtitle1, Title3, tokens } from '@fluentui/react-components';
import { FC } from 'react';
import { useClasses } from '../../App';

const useLocalClasses = makeStyles({
    content: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '80px',
        gap: tokens.spacingVerticalL,
    },
});

interface IData {
    missingVariables: string[];
}

const MissingEnvVariablesError: FC<IData> = ({ missingVariables }) => {
    const classes = useClasses();
    const localClasses = useLocalClasses();

    return (
        <div className={classes.container}>
            <div className={classes.header}>
                <Subtitle1 as="h1">Copilot Chat</Subtitle1>
            </div>
            <div className={localClasses.content}>
                <Title3>
                    {
                        'Please ensure your ".env" file is set up correctly with all environment variables defined in ".env.example" then restart the app.'
                    }
                </Title3>
                <Body1>You are missing the following variables: {missingVariables.join(', ')}</Body1>
            </div>
        </div>
    );
};

export default MissingEnvVariablesError;
